var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"height":"100%","width":"100%"},attrs:{"frameborder":"0","src":_vm.$data.vpn,"marginheight":"1","marginwidth":"1","seamless":"seamless","scrolling":"yes","allowtransparency":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }